import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const BasicInfoStep = ({ formData, onChange, errors }) => {
  const galleryTypeOptions = [
    { value: 'photography', label: 'Photography Portfolio', description: 'Optimized for high-resolution photos' },
    { value: 'videography', label: 'Videography Showcase', description: 'Video streaming and playback' },
    { value: 'mixed', label: 'Mixed Media Gallery', description: 'Photos and videos combined' },
    { value: 'event', label: 'Event Coverage', description: 'Event photos and videos' }
  ];

  const templateOptions = [
    { value: 'grid', label: 'Grid Layout', description: 'Classic grid view' },
    { value: 'masonry', label: 'Masonry Layout', description: 'Pinterest-style layout' },
    { value: 'slideshow', label: 'Slideshow Layout', description: 'Full-screen slideshow' },
    { value: 'timeline', label: 'Timeline Layout', description: 'Chronological display' }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Gallery Information</h3>
        
        <div className="space-y-4 md:space-y-5">
          <Input
            label="Gallery Name"
            type="text"
            placeholder="e.g., Smith Wedding 2026"
            value={formData?.galleryName}
            onChange={(e) => onChange('galleryName', e?.target?.value)}
            error={errors?.galleryName}
            required
            description="Choose a descriptive name for your gallery"
          />

          <Input
            label="Gallery Description"
            type="text"
            placeholder="Brief description of this gallery"
            value={formData?.description}
            onChange={(e) => onChange('description', e?.target?.value)}
            description="Optional: Add context for your clients"
          />

          <Select
            label="Gallery Type"
            options={galleryTypeOptions}
            value={formData?.galleryType}
            onChange={(value) => onChange('galleryType', value)}
            error={errors?.galleryType}
            required
            placeholder="Select gallery type"
          />

          <Select
            label="Layout Template"
            options={templateOptions}
            value={formData?.template}
            onChange={(value) => onChange('template', value)}
            error={errors?.template}
            required
            placeholder="Choose layout style"
          />

          <div className="p-4 rounded-xl bg-muted/50 border border-border">
            <div className="flex items-start gap-3">
              <Checkbox
                id="requireMediaMetadata"
                checked={formData?.requireMediaMetadata ?? true}
                onCheckedChange={(checked) => onChange('requireMediaMetadata', checked)}
              />
              <div className="flex-1">
                <label htmlFor="requireMediaMetadata" className="text-sm font-medium cursor-pointer">
                  Require title and description for media
                </label>
                <p className="text-xs text-muted-foreground mt-1">
                  When enabled, you'll be prompted to add title and description for each photo/video in this gallery
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Client Information</h3>
        
        <div className="space-y-4 md:space-y-5">
          <Input
            label="Client Name"
            type="text"
            placeholder="e.g., John & Sarah Smith"
            value={formData?.clientName}
            onChange={(e) => onChange('clientName', e?.target?.value)}
            error={errors?.clientName}
            required
          />

          <Input
            label="Client Email"
            type="email"
            placeholder="client@example.com"
            value={formData?.clientEmail}
            onChange={(e) => onChange('clientEmail', e?.target?.value)}
            error={errors?.clientEmail}
            required
            description="Primary contact email for gallery access"
          />

          <Input
            label="Client Phone"
            type="tel"
            placeholder="+1 (555) 123-4567"
            value={formData?.clientPhone}
            onChange={(e) => onChange('clientPhone', e?.target?.value)}
            description="Optional: For SMS notifications"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoStep;